module.exports = "<div class=\"text-center\">\n    <img class=\"construction-img\" src=\"../../../assets/img/website-under-construction.jpg\" alt=\"\">\n</div>"